<svg xmlns="http://www.w3.org/2000/svg"
     class="board"
     [attr.viewBox]="viewBoxString()"
     preserveAspectRatio="xMidYMid meet">
    @for (line of board; track $index; let y = $index) {
        <g>
            @for (spaceContent of line; track $index; let x = $index) {
                <g>
                    <g id="click-{{ x }}-{{ y }}"
                       (click)="onClick(x, y)">
                        <!-- Background -->
                        <rect id="space-{{ x }}-{{ y }}"
                              [attr.x]="x * SPACE_SIZE"
                              [attr.y]="y * SPACE_SIZE"
                              [attr.width]="SPACE_SIZE"
                              [attr.height]="SPACE_SIZE"
                              [ngClass]="getSquareClasses(x, y)"
                              class="base"/>
                        <!-- Piece -->
                        @if (spaceContent !== EMPTY) {
                            <circle id="piece-{{ x }}-{{ y }}"
                                    [attr.cx]="SPACE_SIZE/2 + (x * SPACE_SIZE)"
                                    [attr.cy]="SPACE_SIZE/2 + (y * SPACE_SIZE)"
                                    [ngClass]="getPieceClasses(x, y)"
                                    [attr.r]="(SPACE_SIZE / 2) - STROKE_WIDTH"
                                    class="base"/>
                        }
                    </g>
                </g>
            }
        </g>
    }
    @for (coord of targets; track coord.toString()) {
        <rect [attr.x]="coord.x * SPACE_SIZE + (SPACE_SIZE/2 - INDICATOR_SIZE/2)"
              [attr.y]="coord.y * SPACE_SIZE + (SPACE_SIZE/2 - INDICATOR_SIZE/2)"
              [attr.width]="INDICATOR_SIZE"
              [attr.height]="INDICATOR_SIZE"
              (click)="onClick(coord.x, coord.y)"
              class="indicator"/>
    }
</svg>
